<template>
    <template v-if="offer && offer?.region_game_card">
        <div v-if="!type || type == 'default'" class="region-block" :class="{'tooltip-wrap': typeIcon === 2}">
            <img class="region-block__img" :class="{type: typeIcon === 0, 'not-border': typeIcon === 1}" :src="getStatusImage()" alt="Region">
            <div class="region-block__text">
                <span v-if="shorted" @click.prevent="openRegionModal">{{ getStatusTextMobile() }}</span>
                <span v-else>{{ getStatusText() }}</span>
                <a v-if="canShowYourRegion && !shorted" href="#" @click.prevent="openRegionModal"
                     v-html="isGlobal() ? $t('any country') : $t('your region')">
                </a>
            </div>
            <Modal :show="isModalRegionActive" @close="isModalRegionActive = false" :isNowrap="true" :modalClass="'region-block-modal'">
                <div class="region-block-modal__header region-block">
                    <img class="region-block__img" :class="{type: typeIcon === 0, 'not-border': typeIcon === 1}" :src="getStatusImageInModal()" alt="Region">
                    <div class="region-block__text">
                        <span>{{ getStatusText() }}</span>
                        <a v-if="canShowYourRegion" href="#"
                            v-html="isGlobal() ? $t('any country') : $t('your region')">
                        </a>
                    </div>
                    <button @click="isModalRegionActive = false" type="button" class="main-card__close-btn close" data-dismiss="modal" aria-hidden="true">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.0486 0.334961C14.4949 -0.111352 15.2185 -0.111352 15.6648 0.334961C16.1111 0.781274 16.1111 1.50486 15.6648 1.95117L9.61597 8L15.6648 14.0488C16.1111 14.4951 16.1111 15.2187 15.6648 15.665C15.2185 16.1114 14.4949 16.1114 14.0486 15.665L7.99976 9.61621L1.95093 15.665C1.50461 16.1114 0.78103 16.1114 0.334717 15.665C-0.111596 15.2187 -0.111597 14.4951 0.334717 14.0488L6.38354 8L0.334717 1.95117C-0.111597 1.50486 -0.111597 0.781274 0.334717 0.334961C0.78103 -0.111353 1.50461 -0.111353 1.95093 0.334961L7.99976 6.38379L14.0486 0.334961Z" fill="#C9C9C9"/>
                        </svg>
                    </button>
                </div>
                <div class="region-block-modal__body">
                    <div class="region-block-modal__body-top">
                        <div class="region-block-modal__body-top-region">
                            <span class="region-title">{{ $t('Product region') }}</span>
                            <div class="region-wrap">
                                <div class="region-wrap__img">
                                    <img :src="offer?.region_game_card.id === 1 ? '/img/default/global.svg' : offer.region_game_card.image_rounded.orig.src" :alt="offer.region_game_card.image_rounded.orig.alt">
                                </div>
                                <div class="region-wrap__name text-ellipsis" :title="offer.region_game_card.name_tech">
                                    {{ offer.region_game_card.name_tech }}
                                </div>
                            </div>
                        </div>
                        <div class="region-block-modal__body-top-region">
                            <span class="region-title">{{ $t('Your country') }}</span>
                            <div class="region-wrap">
                                <div class="region-wrap__img">
                                    <img :src="userCountry.flag" :alt="userCountry.name">
                                </div>
                                <div class="region-wrap__name">
                                    {{ userCountry.code }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="region-block-modal__body-bottom">
                        <div class="region-block-modal__body-bottom-search" v-if="offer?.region_game_card?.countries?.length > 4">
                            <div class="region-block-modal__body-bottom-search-title">{{ $t('List of allowed countries') }}</div>
                            <input type="text" v-model="searchQuery" @input="filterCountries" :placeholder="$t('Search Country')" />
                        </div>
                        <ScrollFade v-if="filteredCountries.length" class="region-block-modal__body-bottom-scroll" fade-top-class="faded-top" fade-bottom-class="faded">
                            <div class="region-wrap" v-for="countrie in filteredCountries" 
                                :key="countrie.code">
                                <div class="region-wrap__img">
                                    <img :src="countrie.flag" :alt="countrie.code">
                                </div>
                                <div class="region-wrap__name">
                                    {{ countrie.name }}
                                </div>
                            </div>
                        </ScrollFade>
                        <div v-else class="no-results">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.9998 1.16602C9.87558 1.16602 1.6665 9.37509 1.6665 19.4993C1.6665 29.6236 9.87558 37.8327 19.9998 37.8327C30.1241 37.8327 38.3332 29.6236 38.3332 19.4993C38.3332 9.37509 30.1241 1.16602 19.9998 1.16602ZM19.9998 34.7226C11.5943 34.7226 4.77662 27.9049 4.77662 19.4993C4.77662 15.8572 6.0575 12.5098 8.19366 9.89072L29.6085 31.3055C26.9894 33.4417 23.6419 34.7226 19.9998 34.7226ZM31.806 29.108L10.3912 7.69317C13.0103 5.55701 16.3577 4.27613 19.9998 4.27613C28.4053 4.27613 35.223 11.0938 35.223 19.4993C35.223 23.1415 33.9422 26.4889 31.806 29.108Z" fill="#C9C9C9"/>
                            </svg>
    
                            <span>{{ $t('Sorry, your request has no results') }}</span>
                        </div>
                        <div class="region-block-modal__body-bottom-scroll-end" v-if="offer?.region_game_card?.countries?.length > 8">
                            <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.7" fill-rule="evenodd" clip-rule="evenodd" d="M4 0C4.15153 0 4.29684 0.0658408 4.40399 0.183038C4.51113 0.300235 4.57133 0.459188 4.57133 0.62493V7.86537L7.02345 5.18192C7.07657 5.12382 7.13964 5.07773 7.20904 5.04628C7.27844 5.01484 7.35283 4.99865 7.42795 4.99865C7.50308 4.99865 7.57746 5.01484 7.64687 5.04628C7.71627 5.07773 7.77933 5.12382 7.83245 5.18192C7.88557 5.24002 7.92771 5.309 7.95646 5.38492C7.9852 5.46083 8 5.5422 8 5.62437C8 5.70654 7.9852 5.78791 7.95646 5.86382C7.92771 5.93974 7.88557 6.00872 7.83245 6.06682L4.4045 9.8164C4.35143 9.8746 4.28838 9.92077 4.21897 9.95228C4.14956 9.98378 4.07515 10 4 10C3.92485 10 3.85044 9.98378 3.78103 9.95228C3.71162 9.92077 3.64857 9.8746 3.5955 9.8164L0.167549 6.06682C0.114429 6.00872 0.0722926 5.93974 0.0435445 5.86382C0.0147965 5.78791 0 5.70654 0 5.62437C0 5.5422 0.0147965 5.46083 0.0435445 5.38492C0.0722926 5.309 0.114429 5.24002 0.167549 5.18192C0.274829 5.06458 0.420331 4.99865 0.572047 4.99865C0.64717 4.99865 0.721557 5.01484 0.790961 5.04628C0.860365 5.07773 0.923426 5.12382 0.976546 5.18192L3.42867 7.86537V0.62493C3.42867 0.459188 3.48887 0.300235 3.59601 0.183038C3.70316 0.0658408 3.84848 0 4 0Z" fill="#9D9D9D"/>
                            </svg>
                            <span>{{ $t('Scroll down to view more countries') }}</span>
                            <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.7" fill-rule="evenodd" clip-rule="evenodd" d="M4 0C4.15153 0 4.29684 0.0658408 4.40399 0.183038C4.51113 0.300235 4.57133 0.459188 4.57133 0.62493V7.86537L7.02345 5.18192C7.07657 5.12382 7.13964 5.07773 7.20904 5.04628C7.27844 5.01484 7.35283 4.99865 7.42795 4.99865C7.50308 4.99865 7.57746 5.01484 7.64687 5.04628C7.71627 5.07773 7.77933 5.12382 7.83245 5.18192C7.88557 5.24002 7.92771 5.309 7.95646 5.38492C7.9852 5.46083 8 5.5422 8 5.62437C8 5.70654 7.9852 5.78791 7.95646 5.86382C7.92771 5.93974 7.88557 6.00872 7.83245 6.06682L4.4045 9.8164C4.35143 9.8746 4.28838 9.92077 4.21897 9.95228C4.14956 9.98378 4.07515 10 4 10C3.92485 10 3.85044 9.98378 3.78103 9.95228C3.71162 9.92077 3.64857 9.8746 3.5955 9.8164L0.167549 6.06682C0.114429 6.00872 0.0722926 5.93974 0.0435445 5.86382C0.0147965 5.78791 0 5.70654 0 5.62437C0 5.5422 0.0147965 5.46083 0.0435445 5.38492C0.0722926 5.309 0.114429 5.24002 0.167549 5.18192C0.274829 5.06458 0.420331 4.99865 0.572047 4.99865C0.64717 4.99865 0.721557 5.01484 0.790961 5.04628C0.860365 5.07773 0.923426 5.12382 0.976546 5.18192L3.42867 7.86537V0.62493C3.42867 0.459188 3.48887 0.300235 3.59601 0.183038C3.70316 0.0658408 3.84848 0 4 0Z" fill="#9D9D9D"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
        <div v-else-if="type == 'simple'" class="region-block region-simple">
            <div class="region-block__label">
                <img :src="offer.region_game_card.id === 1 ? '/img/default/global.svg' : offer.region_game_card.image_rounded.orig.src" :alt="offer.region_game_card.image_rounded.orig.alt">
                <span class="title">
                    {{ $t('Region') }}:
                </span>
            </div>
            <div class="region-name" :title="offer.region_game_card.name_tech">
                {{ offer.region_game_card.name_tech }}
            </div>
        </div>
        <div v-else-if="type == 'folded'" class="region-block region-folded">
            <div class="region-block__icon">
                <div class="region__access">
                    <img class="region-block__img" :class="{type: typeIcon === 0, 'not-border': typeIcon === 1}" :src="getStatusImage()" alt="Region">
                </div>
                <img class="region-block__flag" :src="offer.region_game_card.id === 1 ? '/img/default/global.svg' : offer.region_game_card.image_rounded.orig.src" :alt="offer.region_game_card.image_rounded.orig.alt">
            </div>
            <div class="region-block__label">
                <span class="title">
                    {{ $t('Region') }}:
                </span>
                <div class="region-name" :title="offer.region_game_card.name_tech">
                    {{ offer.region_game_card.name_tech }}
                </div>
            </div>
        </div>
    </template>
    <div class="region-block placeholder-wrap" v-else>
        <span class="placeholder icon"></span>
        <span class="placeholder text"></span>
    </div>
</template>

<script>
import Modal from '../../../../components/Modal.vue';
import ScrollFade from '../../../../components/ScrollFade.vue';

export default {
    components: {
        Modal,
        ScrollFade
    },
    props: {
      offer: {
        type: Object,
        required: true
      },
      isHead: {
        type: Boolean,
        default: false
      },
      shorted: {
        type: Boolean,
        default: false
      },
      mobile: {
        type: Boolean,
        default: false
      },
      typeIcon: {
        type: Number,
        default: 0
      },
      type: {
        type: String,
        default: 'default'
      }
    },
    data() {
        return {
            searchQuery: '',
            filteredCountries: [],
            activateTypeRegion: 0,
            isModalRegionActive: false,
            userCountry: window.common.country || null,
        };
    },
    mounted() {
        if (this.offer?.id) this.checkRegion();
        this.filteredCountries = this.offer?.region_game_card?.countries || [];
    },
    watch: {
        offer: {
            handler(newVal) {
                if (newVal) this.checkRegion();
                this.filteredCountries = this.offer?.region_game_card?.countries || [];
            },
            deep: true
        }
    },
    methods: {
        isGlobal() {
            return this.offer.region_game_card.name_tech === 'GLOBAL';
        },
        canShowYourRegion() {
            return this.activateTypeRegion === 0 || this.offer.region_game_card.restricted_countries.length !== 0 || (this.activateTypeRegion === 0 && !this.isGlobal()) || this.isGlobal();
        },
        getStatusImageInModal() {
            const statusMap = {
                1: 'load',
                0: 'accept',
                default: 'decline',
            };

            const status =
                statusMap[this.activateTypeRegion] ?? statusMap.default;

            return `/img/tmp/region-${status}.svg`;
        },
        getStatusImage() {
            const statusMap = {
                1: 'load',
                0: 'accept',
            };

            const typeMap = {
                1: 'type_1',
                2: 'type_2',
            };

            const status =
                statusMap[this.activateTypeRegion] || 'decline';

            const typeSuffix =
                typeMap[this.typeIcon]
                ? `-${typeMap[this.typeIcon]}`
                : '';

            return `/img/tmp/region-${status}${typeSuffix}.svg`;
        },
        checkRegion() {
            const region = this.offer?.region_game_card || null;
            const currentCode = this.userCountry.code;

            if (!region || !currentCode) return;

            const hasCountry = region.countries.some(
                country => country.code === currentCode
            );

            const isRestricted = region.restricted_countries?.some(
                country => country.code === currentCode
            );

            if (isRestricted) {
                this.activateTypeRegion = 1;
            } else if (hasCountry || region.id === 1) {
                this.activateTypeRegion = 0;
            } else {
                this.activateTypeRegion = 2;
            }
        },
        filterCountries() {
            const countries = this.offer?.region_game_card?.countries || [];
            const query = this.searchQuery.toLowerCase().trim();

            if (!query) {
                this.filteredCountries = countries;
                return;
            }

            this.filteredCountries = countries.filter(c =>
                c.name.toLowerCase().includes(query) || c.code.toLowerCase().includes(query)
            );
        },
        getStatusText() {
            if (this.activateTypeRegion === 0 && this.isGlobal()) {
                return this.$t('Can be activated from');
            } else if (this.activateTypeRegion === 0) {
                return `${this.$t('Can be activated')} ${this.$t('in')}`;
            } else if (this.activateTypeRegion === 1) {
                return `${this.$t('Activation may be difficult')} ${this.$t("in")}`;
            }

            return `${this.$t("Can't be activated")} ${this.$t("in")}`;
        },
        getStatusTextMobile() {
            if (this.activateTypeRegion === 0) {
                return `${this.$t('Can be activated')}`;
            } else if (this.activateTypeRegion === 1) {
                return `${this.$t('Activation may be difficult')}`;
            }

            return `${this.$t("Can't be activated")}`;
        },
        openRegionModal() {
            this.isModalRegionActive = true;
        }
    }
};
</script>

<style lang="scss">
    .region-block-modal{
        background-color: #fff !important;
        @media only screen and (max-width: 767px) {
            border-radius: 16px 16px 0 0 !important;
        }
        &__header{
            background-color: #F6F5FA;
            padding: 20px 30px;
            display: flex;
            align-items: center;
            gap: 6px;
            @media only screen and (max-width: 767px) {
                padding: 20px 15px;
            }
            .region-block__img{
                width: 30px;
                height: 30px;
                max-width: 30px;
                border-radius: 50%;
            }
            .region-block__text{
                font-family: "Avenir-Next";
                font-weight: 400;
                font-size: 14px;
                line-height: 140%;
                color: #9BA1AB;
                a{
                    color: #4E8AFF !important;
                }
            }
            .close{
                right: 25px;
                top: 23px;
                display: flex;
                align-items: center;
                justify-content: center;
                opacity: 1;
                @media only screen and (max-width: 767px) {
                    right: 25px;
                    top: 24px;
                }
            }
        }
        &__body{
            padding: 30px 30px 0;
            @media only screen and (max-width: 767px) {
                padding: 15px;
            }
            &-top{
                display: flex;
                justify-content: space-between;
                padding-bottom: 30px;
                margin-bottom: 30px;
                border-bottom: 1px solid #E5E5E5;
                @media only screen and (max-width: 767px) {
                    padding-bottom: 15px;
                    margin-bottom: 15px;
                }
                &-region{
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    width: 180px;
                    .region-title{
                        font-family: "Avenir-Next";
                        font-weight: 400;
                        font-size: 16px;
                        line-height: 24px;
                        color: #9D9D9D;
                    }
                    .region-wrap{
                        gap: 10px;
                        &__name{
                            font-family: "Avenir-Next";
                            font-weight: 400;
                            font-size: 16px;
                            line-height: 24px;
                            color: #505050;
                        }
                    }
                }
            }
            &-bottom{
                padding-bottom: 20px;
                @media only screen and (max-width: 767px) {
                    padding-bottom: 0;
                }
                &-search{
                    margin-bottom: 20px;
                    &-title{
                        font-family: "Avenir-Next";
                        font-weight: 400;
                        font-size: 16px;
                        line-height: 24px;
                        letter-spacing: 0px;
                        color: #9D9D9D;
                        margin-bottom: 10px;
                    }
                    input{
                        width: 100%;
                        height: 56px;
                        border: 1px solid #E5E5E5 !important;
                        border-radius: 8px;
                        padding: 0 15px;
                        font-family: "Avenir-Next";
                        font-weight: 400;
                        font-size: 16px;
                        line-height: 140%;
                        color: #505050;
                        &::placeholder{
                            color: #9D9D9D;
                        }
                        &:hover, &:focus{
                            border: 1px solid #E5E5E5 !important;
                            box-shadow: none !important;
                            color: #1F1F1F !important;
                        }
                    }
                }
                &-scroll{
                    max-height: 330px;
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                    overflow-y: scroll;
                    -webkit-overflow-scrolling: touch;
                    .region-wrap{
                        gap: 15px;
                    }
                    &-end{
                        padding: 15px 0 0;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 10px;
                        font-family: "Avenir-Next";
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 140%;
                        color: #9D9D9D;
                        svg{
                            flex-shrink: 0;
                        }
                    }
                }
                
            }
            .region-wrap{
                display: flex;
                align-items: center;
                &__img{
                    width: 24px;
                    max-width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    border: 1px solid #E5E5E5;
                    overflow: hidden;
                    display: flex;
                    justify-content: center;
                    img{
                        max-width: none;
                        height: 100%;
                    }
                }
                &__name{
                    font-family: "Avenir-Next";
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 24px;
                    letter-spacing: 0px;
                    vertical-align: middle;
                    color: #505050;
                }
            }
            .no-results{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 30px;
                padding: 10px 0;
                color: #C9C9C9;
                font-family: "Avenir-Next";
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
            }
        }
    }
</style>

<style lang="scss" scoped>
   .region-block{
        display: flex;
        align-items: center;
        gap: 6px;
        &.placeholder-wrap{
            display: flex;
            align-items: center;
            gap: 6px;
        }
        &.placeholder-wrap{
            pointer-events: none;
            .icon{
                width: 20px;
                height: 20px;
                border-radius: 50%;
            }
            .text{
                width: 200px;
                height: 12px;
                border-radius: 8px;
                @media only screen and (max-width: 1639px) {
                    width: 100px;
                }
            }
        }
        &.tooltip-wrap{
            position: relative;
            @media only screen and (max-width: 1919px) {
                display: none;
            }
            @media only screen and (max-width: 1639px) {
                display: flex;
            }
            .region-block__text{
                position: absolute;
                pointer-events: none;
                opacity: 0;
                transition: 0.4s;
                right: 0;
                bottom: 40px;
                border-radius: 12px;
                padding: 12px 15px;
                box-shadow: 0px 0px 15px 0px #00000026;
                z-index: 100;
                max-width: 260px;
                width: max-content;
                background-color: #fff;
            }
            &:hover{
                .region-block__text{
                    pointer-events: all;
                    opacity: 1;
                }
            }
        }
        &__img{
            width: 24px;
            height: 24px;
            max-width: 24px;
            border-radius: 50%;
            &.type{
                //border: 1px solid #E5E5E5;
            }
            &.not-border{
                border-radius: 0;
            }
        }
        &__text{
            font-family: "Avenir-Next";
            font-weight: 400;
            font-size: 14px;
            line-height: 140%;
            color: #9BA1AB;
            @media only screen and (max-width: 991px) {
                white-space: nowrap;
            }
            a{
                color: #4E8AFF !important;
                padding-left: 3px;
            }
        }
    }
    .region-block {
        &.region-simple {
            display: flex;
            align-items: center;
            gap: 10px;
            .region-block__label {
                display: flex;
                align-items: center;
                gap: 5px;
                min-width: 140px;
                img {
                    width: 24px;
                    height: 24px;
                    max-width: 24px;
                }
            }
        }
        &.region-folded {
            margin-right: auto;
            .region-block__icon {
                border: 1px solid #E5E5E599;
                border-radius: 50px;
                display: flex;
                align-items: center;
                .region__access {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 25px;
                    height: 25px;
                    .region-block__img {
                        width: 16px;
                        height: 16px;
                    }
                }
                .region-block__flag {
                    width: 25px;
                    height: 25px;
                    max-width: 25px;
                    border-radius: 50%;
                }
            }
            .region-block__label {
                display: flex;
                gap: 5px;
                align-items: center;
                white-space: nowrap;
                .title,
                .region-name {
                    font-size: 14px;
                    line-height: 140%;
                    max-width: 130px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    cursor: text !important;
                    @media only screen and (max-width: 1640px) {
                        max-width: 105px;
                    }
                }
                .region-name {
                    @media only screen and (max-width: 1200px) {
                        max-width: 70px;
                    }
                }
            }
        }
        .region-block__label {
            color: #9D9D9D;
            font-family: 'Avenir-Next';
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
        }
        .region-name {
            color: #505050;
            font-family: 'Avenir-Next';
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
        }
    }
</style>